<template>
  <div class="swipertwo">
    <div class="swiper mySwiper1">
      <div class="swiper-wrapper">
        <!-- <div
          class="swiper-slide"
          style="width: 250px; height: 330px ;border:1px solid red"
          v-for="item in actlist1.slice(0, 9)"
          v-bind:key="item.id"
          @click="handlelitxq(item.id)"
        > -->
        <router-link :to="'/show?id=' + item.id" v-for="(item,index) in actlist1.slice(0, 9)"
          v-bind:key="item.id" class="swiper-slide routerbox" style="width: 250px; height: 330px ;">
          <!-- <img :src="item.files.length ? item.files[0].src : require('../../assets/images/39.png')" alt="" /> -->
          <img :src="qqqlfmimg[index] == '' ? require('../../assets/images/39.png') : qqqlfmimg[index]"
            alt=""/>
          <div>
            <h3 class="two-line" v-html="item.title"></h3>

            <p v-if="item.summary" class="two-line">{{ item.summary }}</p>
            <p v-else class="f-line">{{ item.content | ellipsis }}</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "@/swiper/swiper-bundle.min.js";
import { news } from "@/api/index.js";
export default {
  name: "swipertwo",
  filters: {
    ellipsis(value) {
      // 正则去除html标签
      if (value.match(/[\u4e00-\u9fa5]/g)) {
        value = value.match(/[\u4e00-\u9fa5]/g).join("");
      } else {
        return;
      }
      // 不为空将显示字数小于90个
      if (value.length > 100) {
        return value.slice(0, 100) + "...";
      }
      return value;
    },
  },

  data() {
    return {
      // 专题活动
      actlist1: [],
      qqqlfmimg:[],
    };
  },
  created() {
    news({ siteId: 5, cate_id: 110,online: 1  }).then((res) => {
      this.actlist1 = res.data.data.records;
      this.actlist1.forEach((item) => {
        item.files = JSON.parse(item.files);
      });
      this.actlist1.map((item,index) => {
          if( item.files.length == 0) {
              this.qqqlfmimg[index] = ""
          }else {
            if(item.files.fmimg == undefined) {
              item.files.map(items => {
                if(this.getFileType(items.src) == 'image') {
                  this.qqqlfmimg.push(items.src)
                }
                else {
                    this.qqqlfmimg.push('')
                }
              })
            }else {
              if(item.files.fmimg.length == 0) {
                    this.qqqlfmimg.push('')
                }else {
                  this.qqqlfmimg.push(item.files.fmimg[0].src)
                }
            }
          }
        })
      //
    });
  },
  mounted: function () {
    var swiper = new Swiper(".mySwiper1", {
      watchSlidesProgress: true,
      slidesPerView: 3,
      autoplay: {
        delay: 5000, //3秒切换一次
        pauseOnMouseEnter: true, //悬停停止切换
      },
    });
  },
  methods: {
    handlelitxq(id) {
      this.$router.push({ path: "show", query: { id: id } });
    },
    /* 根据后缀判断文件类型 */
    getFileType(fileName) {
      let suffix = ''; // 后缀获取
      let result = ''; // 获取类型结果
      if (fileName) {
        const flieArr = fileName.split('.'); // 根据.分割数组
        suffix = flieArr[flieArr.length - 1]; // 取最后一个
      }
      if (!suffix) return false; // fileName无后缀返回false
      suffix = suffix.toLocaleLowerCase(); // 将后缀所有字母改为小写方便操作
      // 匹配图片
      const imgList = ['png', 'jpg', 'jpeg', 'bmp',"JPG","PNG","JPEG","BMP"]; // 图片格式
      result = imgList.find(item => item === suffix);
      if (result) return 'image';
      // 匹配txt
      const txtList = ['txt'];
      result = txtList.find(item => item === suffix);
      if (result) return 'txt';
      // 匹配excel
      const excelList = ['xls', 'xlsx'];
      result = excelList.find(item => item === suffix);
      if (result) return 'excel';
      // 匹配word
      const wordList = ['doc', 'docx'];
      result = wordList.find(item => item === suffix);
      if (result) return 'word';
      // 匹配pdf
      const pdfList = ['pdf'];
      result = pdfList.find(item => item === suffix);
      if (result) return 'pdf';
      // 匹配ppt
      const pptList = ['ppt', 'pptx'];
      result = pptList.find(item => item === suffix);
      if (result) return 'ppt';
      // 匹配zip
      const zipList = ['rar', 'zip', '7z'];
      result = zipList.find(item => item === suffix);
      if (result) return 'zip';
      // 匹配视频
      const videoList = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videoList.find(item => item === suffix);
      if (result) return 'video';
      // 匹配音频
      const radioList = ['mp3', 'wav', 'wmv'];
      result = radioList.find(item => item === suffix);
      if (result) return 'radio';
      // 其他文件类型
      return 'other';
    },
  },
};
</script>
<style lang="less" scoped>
.swipertwo {
  max-width: 840px;
  max-height: 375px;
  @media screen and (max-width: 1150px) {
    max-width: 100%;
  }
}
.swiper-slide > img {
  width: 265px;
  height: 160px;
  @media screen and (max-width: 1150px) {
    width: 100%;
  }
}
.swiper {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  width: 265px !important;
  // height: 330px;
  margin-left: 15px;
  text-align: center;
  cursor: pointer;
  @media screen and (max-width: 1150px) {
    width: 33% !important;
  }
}
.swiper-slide:first-child {
  margin-left: 0;
}
.swiper-slide {
  background: #f4f6ff;
}
// .swiper-slide > div {
//   // height: 170px;
// }
.swiper-slide > div > h3 {
  margin-top: 20px;
  border-bottom: 1px dashed #000;
  padding-bottom: 3px;
  font-size: 16px;
}
.swiper-slide > div > h3:hover{
  color:#ff9900
}
.swiper-slide > div > p {
  color: #7a7a7a;
  font-size: 12px;
  margin-top: 15px;
  text-align: left;
}
.swiper-slide > div {
  margin: 10px 30px 0 30px;
}
@media screen and(max-width:360px) {
  .swiper-wrapper {
    display: block;
  }
}
.routerbox,
.routerbox:visited {
  color: #333;
}
</style>
